import axiosInstance from "../../config/axiosConfig";

export const logOut = async () => {
  return axiosInstance.post(`authentication/logout`).then((res) => res.data);
};
